Translator:
    en: 'Translator editor'
    fr: 'Translator editor'
    pt: 'Editor de tradução'
    es: 'Translator editor'
    ru: 'Редактор переводов'
verified:
    da: Bekræftet
    en: Verified
    es: Verificado
    fr: Verifié
    pt: Verificado
    ru: Проверено
    us: Verified
pagination:
    en: '{0} of {1}'
    es: '{0} de {1}'
    fr: '{0} de {1}'
    pt: '{0} de {1}'
    ru: '{0} из {1}'
gridColumnVisibility:
    en: 'Visibility of columns'
    ru: 'Видимость колонок'
    pt: 'Visibilidade das colunas'
    es: 'La visibilidad de las columnas'
    fr: 'La visibilité des colonnes'
gridNoData:
    en: 'No data'
    es: 'No hay datos'
    fr: 'Aucune donnée'
    pt: 'Sem dados'
    ru: 'Нет данных'
itemsPerPage:
    en: 'items per page'
    ru: 'Элементов на странице'
    es: 'Artículos por página'
    fr: 'Lignes par page'
    pt: 'Itens por página'
paginationItem:
    en: items
    ru: элементов
    fr: lignes
    pt: itens
    es: artículos
waitTitle:
    en: 'Please Wait...'
    es: 'Por favor, espere'
    fr: 'Veuillez patienter...'
    pt: 'Por favor espere...'
    ru: 'Пожалуйста, подождите...'
whatsNew:
    en: "What's new"
    es: 'Que es nuevo'
    fr: ''
    pt: 'O que é novo?'
    ru: 'Что нового'
supportEmail:
    en: support@maxoptra.com
    es: support@maxoptra.com
    pt: support@maxoptra.com
    ru: support@maxoptra.ru
documentationLink:
    en: 'https://doc.maxoptra.com'
    es: 'https://doc.maxoptra.com'
    pt: 'https://doc.maxoptra.com'
    ru: 'https://doc.maxoptra.com'
saveConfirm:
    en: 'You have unsaved changes. Do you want to save them before closing?'
    es: 'Tienes cambios no guardados. ¿Quieres salvarlos antes de cerrar?'
    fr: 'You have unsaved changes. Do you want to save them before closing?'
    pt: 'Não guardou as alterações efetuadas. Pretende fazê-lo antes de fechar?'
    ru: 'Есть не сохраненные изменения. Вы хотите сохранить их перед закрытием окна?'
deleteConfirmation:
    en: 'Are you sure you want to delete?'
    es: '¿Estás seguro que quieres borrar?'
    fr: 'Etes-vous sûr de vouloir supprimer?'
    pt: 'Tem a certeza que quer apagar?'
    ru: 'Вы действительно хотите удалить?'

confirmUnallocate:
    en: 'Are you sure you want to unallocate all not fixed runs on {0}?'
    ru: 'Вы уверены, что хотите отпланировать все незафиксированные поездки на {0}?'
    es: '¿Estás seguro que quieres des-asignar todas las ejecuciones no fijas en {0}?'
    pt: 'Tem a certeza que deseja anular a atribuição das rotas não fixa {0}?'
    fr: "Etes-vous sur de vouloir annuler l'allocation pour toutes les commandes non fixées au {0}?"
unplanningRun:
    en: 'Are you sure you want to unallocate all orders from run #{0} on {1} and remove run from schedule?'
    ru: 'Вы уверены, что хотите отпланировать все заказы с поездки #{0} на {1} и удалить поездку?'
    es:
        '¿Estás seguro que quieres des-asignar todos los pedidos desde la ejecución #{0} sobre {1} y borrar la ejecución
        desde la programación?'
    pt: 'Tem a certeza que deseja anular a atribuição da rota #{0} em {1} e remover a rota do planeamento?'
    fr:
        'Etes-vous sur de vouloir dissocier toutes les commandes de la tournée #{0} du {1} et retirer la tournée du
        planning ?'
confirmCommit:
    en: 'Are you sure you want to lock schedule on {0}?'
    ru: 'Вы уверены, что хотите зафиксировать расписание на {0}?'
    es: '¿Estás seguro que quieres bloquear la programación en {0}?'
    pt: 'Tem a certeza de que pretende bloquear o planeamento de {0}?'
    fr: 'Etes-vous sur de vouloir verrouiller le planning au {0}?'
confirmCancelCommit:
    en: 'Are you sure you want to unlock schedule on {0}?'
    ru: 'Вы уверены, что хотите отменить фиксацию расписания на {0}?'
    es: '¿Estás seguro que quieres desbloquear la programación en {0}?'
    pt: 'Tem a certeza que pretende desbloquear a planeamento de {0}?'
    fr: 'Etes-vous sur de vouloir déverrouiller le planning au {0}?'
schedulingStartForHistoricalTrafficConfirm:
    en: 'New planning will modify existing schedule. Do you want to proceed?'
    es: 'La nueva planificación modificará la programación existente. ¿Quieres seguir?'
    fr: 'La nouvelle planification va modifier le planning existant. Voulez-vous continuer ?'
    pt: 'Um novo planeamento irá modificar o existente. Deseja continuar?'
    ru: 'Новое планирование изменит существующее расписание. Продолжить?'
schedulingStartConfirm:
    en: 'New planning will modify existing schedule.'
    es: 'La nueva planificación modificará la programación existente.'
    fr: 'La nouvelle planification va modifier le planning existant.'
    pt: 'Um novo planeamento irá modificar o existente.'
    ru: 'Новое планирование изменит существующее расписание.'
viewOptions:
    en: 'View options'
    ru: 'Вид'
    es: 'Vista de opciones'
    pt: 'Ver opções'
    fr: "Options d'affichage"
scheduleActions:
    en: 'Schedule actions'
    ru: 'Расписание'
    es: 'Acciones de programación'
    pt: 'Ações de planeamento'
    fr: 'Options planning'
enableAutoresequencing:
    en: 'Enable autoresequencing'
    ru: 'Включить автоматическое упорядочивание'
    es: 'Permitir auto-secuenciación'
    pt: 'Permitir autossequenciação'
    fr: "Activer remise en ordre de l'automobile"
zoom:
    en: 'Zoom'
    ru: 'Масштаб'
    es: 'Zoom'
    pt: 'Zoom'
    fr: 'Zoom'
count:
    en: 'Count'
    ru: 'Количество'
#Progress dialog and optimise button ->
runPlanning:
    en: 'Optimise'
    es: 'Programar'
    pt: 'Planear'
    ru: 'Планировать'
    fr: 'Optimiser'
recalculate:
    en: 'Recalculate'
    es: 'Actualizar'
    pt: 'Atualizar'
    ru: 'Пересчитать'
reoptimize:
    en: Reoptimise
    ru: Планирование
    es: Reoptimizar
    pt: Reotmizar
optimizing: 
    en: Optimizing
    ru: Планирование
    es: Optimizando
    pt: Otimizando
recalculating:
    en: Recalculating
    ru: Пересчет
    es: Recalculando
    pt: Recalculando
incrementally:
    en: Incrementally
    ru: Допланирование
    es: Incrementalmente
    pt: Incrementalmente
distanceCalculation:
    en: 'Distance calculation'
    es: 'Cálculo de la distancia'
    fr: 'Calcul de distance'
    pt: 'Cálculo da distância'
    ru: 'Расчет расстояний'
scheduling:
    en: 'Planning & Optimisation'
    es: 'Planificación y Optimización'
    fr: 'Planning & optimisation'
    pt: 'Planeamento & Otimização'
    ru: 'Планирование и оптимизация'
resultStoring:
    en: 'Saving results'
    es: 'Guardando los resultados'
    fr: 'Sauvegarder les résultats'
    pt: 'A guardar resultados'
    ru: 'Сохранение результатов'
planningSessionIsRunning:
    en: 'Planning session is running'
    es: 'La sesión de planificación esta ejecutandose'
    fr: 'Session de planification en cours'
    pt: 'Está a decorrer um planeamento'
    ru: 'Идет сессия планирования'
playSoundOnPlanningCompleted:
    en: 'Play a sound once completed (requires speakers)'
    ru: 'Воспроизвести звук после завершения (требуются динамики)'
planningStartedAt:
    en: 'Started at'
    es: 'Se inició a las'
    fr: 'Débutée le'
    pt: 'Inicio a'
    ru: 'Запущена'
schedulingResult:
    en: 'Planning result'
    es: 'Resultado de la planificación'
    fr: 'Résultat de planification'
    pt: 'Resultados de Planeamento'
    ru: 'Результат планирования'
terminateSession:
    en: 'Terminate session'
    es: 'Sesión terminada'
    fr: 'Session terminée'
    pt: 'Fechar sessão'
    ru: 'Остановить сессию'
wantStopPlanning:
    en: 'Are you sure you want to stop planning?'
    es: '¿Estás seguro que quieres parar la planificación?'
    fr: 'Etes vous sur de vouloir arrêter la planification?'
    pt: 'Tem a certeza que pretende cancelar o planeamento?'
    ru: 'Вы действительно хотите остановить планирование?'
zoomIn:
    en: 'Zoom in'
    ru: 'Увеличить'
    es: 'Acercar'
    pt: 'Aumentar'
    fr: 'Zoomer'
any:
    en: 'Any'
    ru: 'Любой'
    es: 'Cualquiera'
    pt: 'Qualquer'
    fr: 'Tous'
addressPlaceholder:
    en: Select an address
    ru: Выберите адрес
    es: Selecciona una dirección
    pt: Selecione um endereço
    fr: Sélectionnez une adresse
default: 
    en: 'Default'
    ru: 'Обычный'
    es: 'Por defecto'
    pt: 'Padrão'
    fr: 'Par défaut'
satellite:
    en: 'Satellite'
    ru: 'Спутник'
    es: 'Satélite'
    pt: 'Satélite'
    fr: 'Satellite'
hide: 
    en: 'Hide'
    ru: 'Скрыть'
    es: 'Ocultar'
    pt: 'Esconder'
    fr: 'Cacher'
expand: 
    en: 'Expand'
    ru: 'Развернуть'
    es: 'Expandir'
    pt: 'Expandir'
    fr: 'Développer'
